import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';

type ConsolidatePDFPayload = BaseContext & {
	id?: string;
	locale: string;
};

async function consolidatePDF(payload: any) {
	const { id, ...rest } = payload;
	const url = `/ergonomic-tool/rosa/consolidate/${id}`;
	const { data } = await Api.put<any>(url, rest);
	return data;
}

export const useConsolidatePDF = () => {
	return useMutation((body: ConsolidatePDFPayload) => consolidatePDF(body), {
		onError: () => {
			message.error(I18n.get('Failed to consolidate PDF'));
		}
	});
};
